import { inject } from "@angular/core";

import { AuthenticationService } from "../_services/authentication.service";

export function authAppInitializerFactory() {
  const authService = inject(AuthenticationService);
  return authService.runInitialLoginSequence();
}
